(function() {
    'use strict';
    angular.module('showcaseApp').component('customSimpleSelect', {
        templateUrl: 'app/components/custom-simple-select/custom-simple-select.html',
        controller: CustomSimpleSelectController,
        controllerAs: 'vm',
        bindings: {
            options: '<',
            model: '=',
            placeholder: '@',
            onSelect: '&'
        }
    });

    function CustomSimpleSelectController($element, $document, $scope) {
        var vm = this;
        vm.showTypeOptions = false;

        vm.toggle = function() {
            vm.showTypeOptions = !vm.showTypeOptions;
        };

        vm.select = function(value) {
            vm.model = value;
            vm.showTypeOptions = false;

            if (vm.onSelect) {
                vm.onSelect({ value: value });
            }
        };

        vm.getSelectedLabel = function() {
            if (!vm.options || vm.model === undefined || vm.model === '') {
                return vm.placeholder;
            }
            var selected = vm.options.find(function(opt) {
                return opt === vm.model;
            });
            return selected ? selected.name : vm.placeholder;
        };

        var onClickOutside = function(event) {
            if (!$element[0].contains(event.target)) {
                $scope.$apply(function() { vm.showTypeOptions = false; });
            }
        };

        vm.$onInit = function() { $document.on('click', onClickOutside); };
        vm.$onDestroy = function() { $document.off('click', onClickOutside); };
    }
})();
